import {sendPdpAddToCartClickedEvent} from '../../jquery/algolia/algolia.tracking';

class AddToCartService {
    /*@ngInject*/
    constructor($log, $http, $rootScope, CommonService) {
        this.$log = $log;
        this.$http = $http;
        this.$rootScope = $rootScope;
        this.addToCartResponse = null;
        this.CommonService = CommonService;
    }

    getAddToCartResponse() {
        return this.addToCartResponse;
    }

    dyAddToCartEvent(addToCartProperties) {
        console.log(addToCartProperties);
    }

    addToCart(code, qty, ean, size, price, isOneSize, hasDummyVariant) {
        let algoliaQueryId = $('body').attr('data-algolia-queryId');
        if(algoliaQueryId === undefined) {
            algoliaQueryId = '';
        }
        this.$log.debug('add to cart ' + code);
        let url = this.CommonService.getBaseUrl() + '/cart/add?productCodePost=' + code + '&algoliaQueryId=' + algoliaQueryId;
        let req = {
            method: 'POST',
            url: url,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: {
                qty: qty
            }
        };

        this.$http(req).then((response) => {
            this.addToCartResponse = response.data;
            this.$rootScope.$broadcast('addToCartFinished');
            if (this.addToCartResponse.result.success) {
                this.$rootScope.$broadcast('addToCartSuccess');
                /* LSEC-8738 Google analytics for adding product to cart from product detail page */
                let trackedProduct = this.resolveTrackedProduct();
                if (trackedProduct !== null && window.dataLayer !== undefined) {
                    dataLayer.push({
                        'event': 'addToCart',
                        'ecommerce': {
                            'currencyCode': 'EUR',
                            'add': {
                                'products': [{
                                    'id': code.substr(0, 10),
                                    'name': trackedProduct.name,
                                    'price': trackedProduct.price,
                                    'brand': trackedProduct.brand,
                                    'category': trackedProduct.category,
                                    'gender': trackedProduct.gender,
                                    'genderGlobal': trackedProduct.genderGlobal,
                                    'type': trackedProduct.type,
                                    'typeGlobal': trackedProduct.typeGlobal,
                                    'ean': ean,
                                    'size': size,
                                    'quantity': qty
                                }]
                            }
                        }
                    });
                }

                if($('body').hasClass('page-productDetailPage')) {
                    let objectID = code;
                    if(isOneSize === 'true' && hasDummyVariant === 'true') {
                        objectID = objectID.slice(0, -3);
                    }
                    sendPdpAddToCartClickedEvent(algoliaQueryId, objectID, qty, price);
                }


                /* Dynamic Yield analytics add to cart event*/
                const addToCartProperties = this.addToCartResponse.result.dyAddToCartEvent.properties;
                executeDYWithDelay(Date.now(), function() {
                   DY.API("event", {
                       name: "Add to Cart",
                       properties: addToCartProperties
                   });
                });
            }
        }, (error) => {
            this.$log.error('add to cart: ' + error.status + ' ' + error.statusText);
        });
    }

    resolveTrackedProduct() {
        if (window.dataLayer !== undefined) {
            for (let i = 0; i < dataLayer.length; i++) {
                if (dataLayer[i] !== undefined && dataLayer[i].ecommerce !== undefined && dataLayer[i].ecommerce.detail !== undefined) {
                    return dataLayer[i].ecommerce.detail.products["0"];
                }
            }
        }
        return null;
    }
}

export default AddToCartService;
